import { useState } from "react";
import api from "../../../../../features/auth/axiosConfig";
import { notifyError, notifySuccess } from "../../../../../assets/toastService";
import { isValidDate } from "../utils/validation";

export const useBranchUpdate = (id: string, formData: any, closeEdit: () => void, fetchBranches: () => void, dateDirty: boolean,) => {
  const [loading, setLoading] = useState(false);
  const [disabled, setDisabled] = useState(false);

  const updateBranch = async () => {
    if (disabled) return;

    if (dateDirty) {
      if (!formData.branchopeningdate) {
        notifyError("Please select a valid Branch Opening Date.");
        return;
      }

      if (!/^\d{2}-\d{2}-\d{4}$/.test(formData.branchopeningdate)) {
        notifyError("Please enter date in dd-mm-yyyy format");
        return;
      }

      const [day, month, year] = formData.branchopeningdate.split("-").map(Number);
      if (!isValidDate(day, month, year)) {
        notifyError("Please enter a valid date");
        return;
      }
    }

    const data = {
      Branch_name: formData.Branchname,
      Branch_Opening_date: formData.branchopeningdate,
      Address: {
        address1: formData.address1,
        street: formData.street,
        Pincode: formData.Pincode?.length > 0 ? formData.Pincode : undefined,
        selectedCountry: formData.selectedCountry,
        selectedState: formData.selectedState,
        selectedCity: formData.selectedCity,
      },
    };

    try {
      setLoading(true);
      setDisabled(true);
      await api.put(`/app/v1/pos/branch/${id}`, data);
      notifySuccess("Branch Updated successfully");
      setTimeout(() => {
        closeEdit();
        fetchBranches();
        setDisabled(false);
      }, 3000);
    } catch {
      notifyError("Failed to update branch. Please try again.");
      setDisabled(false);
    } finally {
      setLoading(false);
    }
  };

  return { loading, updateBranch };
};
